import { TypedEpic } from 'redux-observable';
import core, { App, GQL } from '@gin-betting/core';
import banners, { BannerTypes } from '@gin-betting/banners';

import { isMobile } from 'app-constants';
import { GET_TOP_TOURNAMENTS_SUCCESS } from './constants';
import { setNormalizeTournaments } from './actions';
import { GetBannerZones } from './types';

const {
    entities: {
        normalizeEntity,
        constants: { GET_SPORTS_SUCCESS },
    },
    utils: { getSportTypeFromLocation },
} = core;

const {
    actions: { getAvailableBannerZones },
} = banners;

export const normalizeTopTournaments: TypedEpic<
    App.ApiResponseAction<
        typeof GET_TOP_TOURNAMENTS_SUCCESS,
        GQL.GetTopTournamentsQuery
    >,
    ReturnType<typeof setNormalizeTournaments>
> = actions$ => {
    return actions$.ofType(GET_TOP_TOURNAMENTS_SUCCESS).map(action => {
        const {
            data: { topTournaments },
        } = action.payload;

        const tournaments = topTournaments.map(
            topTournament => topTournament.tournament
        );

        const normalizeTournaments = normalizeEntity({ tournaments });

        return setNormalizeTournaments(normalizeTournaments);
    });
};

export const getBannerZones: GetBannerZones = (actions$, store) => {
    return actions$.ofType(GET_SPORTS_SUCCESS).map(() => {
        const platform = isMobile
            ? BannerTypes.BannerZonePlatform.MOBILE
            : BannerTypes.BannerZonePlatform.DESKTOP;

        const sportType = getSportTypeFromLocation();

        return getAvailableBannerZones({
            pageType: sportType,
            platform,
        });
    });
};
